// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'
import type { Rules } from 'frame/core/formValidate'

import React from 'react'
import computeData from '../hoc/computeData'
import { validate } from 'frame/core/formValidate'

type Props = BasicProps & {
  fileField: string,
  base64Field: string,
  rules: Rules,
  formValues: { [string]: string },
  setFormValues: ({ [key: string]: any }) => void
};

@computeData()
export default class OpenImg extends React.PureComponent<Props> {
  fileInput: ?HTMLInputElement;

  static schema: PropsSchema = [
    {
      key: 'base64Field',
      title: 'base64字段',
      type: 'text'
    },
    {
      key: 'fileField',
      title: 'file字段',
      type: 'text'
    },
    {
      title: '校验规则列表',
      type: 'array',
      key: 'rules',
      item: [
        {
          type: 'select',
          key: 'type',
          title: '规则：',
          options: [['required', '必填']],
          defaultValue: 'required'
        },
        {
          type: 'text',
          key: 'message',
          title: '提示消息'
        }
      ]
    },
    'separator',
    {
      type: 'event',
      title: '改变',
      event: 'onChange'
    },
    {
      type: 'event',
      title: '用户操作改变',
      event: 'userOperationChange'
    },
    {
      type: 'event',
      title: '校验成功',
      event: 'resolve'
    },
    {
      type: 'event',
      title: '校验失败',
      event: 'reject'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '选择图片',
      name: 'selectImg'
    },
    {
      title: '数据校验',
      name: 'validate'
    }
  ];

  actionSelectImg = () => {
    if (this.fileInput) {
      this.fileInput.click()
    }
  };

  actionValidate = () => {
    const { callActions, rules } = this.props
    const fieldValue = this.getFieldValue()
    if (rules && rules.length > 0) {
      const error = validate(fieldValue, rules)
      if (!error.success) {
        callActions('reject', error)
      } else {
        callActions('resolve')
      }
    } else {
      callActions('resolve')
    }
  };

  imageChanged = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const { setFormValues, fileField, base64Field, callActions } = this.props
    const _compress = this.compress
    const base64ToFile = this.base64ToFile
    const file = event.target.files[0]
    if (file) {
      var reader = new window.FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        let img = new Image()
        img.src = this.result
        img.onload = function () {
          const base64 = _compress(img)
          let imgFile
          if (fileField) {
            imgFile = base64ToFile(base64, file.name)
            setFormValues({ [fileField]: imgFile })
          }
          if (base64Field) {
            setFormValues({ [base64Field]: base64 })
          }
          callActions('userOperationChange', base64 || imgFile)
        }
      }
    }
  };

  compress = (img: Image) => {
    let canvas = document.createElement('canvas')
    let tCanvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const tctx = tCanvas.getContext('2d')
    let width = img.width
    let height = img.height
    // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
    let ratio = width * height / 4000000
    if (ratio > 1) {
      ratio = Math.sqrt(ratio)
      width /= ratio
      height /= ratio
    } else {
      ratio = 1
    }
    canvas.width = width
    canvas.height = height
    // 铺底色
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    // 如果图片像素大于100万则使用瓦片绘制
    let count = width * height / 1000000
    if (count > 1) {
      count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片

      // 计算每块瓦片的宽和高
      let nw = ~~(width / count)
      let nh = ~~(height / count)

      tCanvas.width = nw
      tCanvas.height = nh

      for (var i = 0; i < count; i++) {
        for (var j = 0; j < count; j++) {
          tctx.drawImage(
            img,
            i * nw * ratio,
            j * nh * ratio,
            nw * ratio,
            nh * ratio,
            0,
            0,
            nw,
            nh
          )

          ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
        }
      }
    } else {
      ctx.drawImage(img, 0, 0, width, height)
    }
    // 进行最小压缩
    const ndata = canvas.toDataURL('image/jpeg', 0.1)
    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
    return ndata
  };

  base64ToFile = (bases64Str: string, fileName: string) => {
    let byteString = atob(bases64Str.split(',')[1])
    let mimeString = bases64Str
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]
    // 类型数组
    let ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return {
      blob: new Blob([ia], {
        type: mimeString
      }),
      fileName
    }
  };

  getFieldValue = (props?: Props): string => {
    const { base64Field, fileField, formValues } = props || this.props
    return formValues[base64Field || fileField] == null
      ? ''
      : formValues[base64Field || fileField]
  };

  componentDidUpdate (preProps: Props) {
    let { callActions } = this.props
    if (this.getFieldValue(preProps) !== this.getFieldValue()) {
      callActions('onChange', this.getFieldValue())
    }
  }

  render () {
    return (
      <input
        style={{ display: 'none' }}
        ref={(ref: ?HTMLInputElement) => {
          this.fileInput = ref
        }}
        accept='image/*'
        onChange={e => {
          this.imageChanged(e)
        }}
        type='file'
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/OpenImg.js